if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');

        this.selectedVariantMediaId =
          this.dataset.selectedVariantMediaId || null;

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 500)
        );

        this.elements.thumbnails
          .querySelectorAll('[data-target]')
          .forEach((mediaToSwitch) => {
            const button = mediaToSwitch.querySelector('button');

            if (!button) return;

            button.addEventListener(
              'click',
              this.setActiveMedia.bind(
                this,
                mediaToSwitch.dataset.target,
                false
              )
            );
          });

        this.updateVariantThumbnailVisibility(
          this.selectedVariantMediaId
        );

        const initialActiveMedia =
          this.elements.viewer.querySelector(
            '[data-media-id].is-active'
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (initialActiveMedia) {
          const initialActiveThumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${initialActiveMedia.dataset.mediaId}"]`
            );

          this.setActiveThumbnail(initialActiveThumbnail);
        }

        if (
          this.dataset.desktopLayout.includes('thumbnail') &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const currentMediaId =
          event.detail.currentElement.dataset.mediaId;

        const thumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${currentMediaId}"]`
          );

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(
            `[data-media-id="${mediaId}"]`
          ) ||
          this.elements.viewer.querySelector(
            '[data-media-id]'
          );

        if (!activeMedia) return;

        if (prepend) {
          this.selectedVariantMediaId = mediaId;

          this.updateVariantThumbnailVisibility(
            this.selectedVariantMediaId
          );
        }

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (
            activeMedia.parentElement.firstElementChild !==
            activeMedia
          ) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }

          const activeMediaRect =
            activeMedia.getBoundingClientRect();

          if (activeMediaRect.top > -0.5) return;

          const top =
            activeMediaRect.top + window.scrollY;

          window.scrollTo({
            top,
            behavior: 'smooth',
          });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(activeThumbnail);

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset.mediaPosition
          );
        }
      }

      updateVariantThumbnailVisibility(selectedMediaId) {
        if (!this.elements.thumbnails) return;

        const variantThumbnails =
          this.elements.thumbnails.querySelectorAll(
            '[data-variant-thumbnail="true"]'
          );

        variantThumbnails.forEach((thumbnail) => {
          thumbnail.hidden =
            !selectedMediaId ||
            thumbnail.dataset.target !== selectedMediaId;
        });

        this.elements.thumbnails.resetPages?.();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails) return;

        const thumbnailItems =
          this.elements.thumbnails.querySelectorAll(
            '[data-target]'
          );

        thumbnailItems.forEach((item) => {
          item.classList.remove('is-current-thumbnail');

          item
            .querySelector('button')
            ?.removeAttribute('aria-current');
        });

        if (!thumbnail) {
          this.elements.thumbnails.resetPages?.();
          return;
        }

        thumbnail.classList.add('is-current-thumbnail');

        thumbnail
          .querySelector('button')
          ?.setAttribute('aria-current', 'true');

        this.elements.thumbnails.resetPages?.();

        if (
          thumbnail.hidden ||
          (
            typeof this.elements.thumbnails.isSlideVisible ===
              'function' &&
            this.elements.thumbnails.isSlideVisible(
              thumbnail,
              10
            )
          )
        ) {
          return;
        }

        this.elements.thumbnails.slider?.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            'aria-hidden',
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              'aria-hidden',
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();

        const deferredMedia =
          activeItem.querySelector('.deferred-media');

        if (deferredMedia) {
          deferredMedia.loadContent(false);
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) => {
            slide.setAttribute(
              'role',
              'presentation'
            );
          }
        );
      }
    }
  );
}